import React, { useEffect, useState } from "react";
import styles from "../ProductDetails.module.scss";
import LetterSwatches from "./LetterSwatches";
import Swatches from "../../common/Swatches.js";

/* 
This component is used to show the letter swatches for the items that have letters as the variants
*/
export default function ProductLetterPicker({
  swatchesData,
  selectedLetter,
  setSelectedLetter,
  stickyProductBox,
  isStickySwatchesOpen,
  showStickySwatches,
  variantsData,
  showLastOne
}) {
  return (
    <>
      <div className={`${styles.letter_picker}`}>
        <Swatches
          data={swatchesData}
          selected={selectedLetter}
          setSelected={setSelectedLetter}
          stickyProductBox={stickyProductBox}
          isStickySwatchesOpen={isStickySwatchesOpen}
          showStickySwatches={showStickySwatches}
          ArrowDown="images/Icons/Chevron/large.svg"
          type="letter"
          id="letterPicker"
          variantsData={variantsData}
          showLastOne={showLastOne}
        />
      </div>
    </>
  );
}
